// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Localforage from "localforage";
import * as Pages$Coronate from "./Pages.res.js";
import * as Router$Coronate from "./Router.res.js";
import * as Window$Coronate from "./Window.res.js";
import * as Client from "react-dom/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as PageOptions$Coronate from "./PageOptions.res.js";
import * as PagePlayers$Coronate from "./PagePlayers.res.js";
import * as PageTourney$Coronate from "./PageTournament/PageTourney.res.js";
import * as LocalforageGetitems from "localforage-getitems";
import * as LocalforageSetitems from "localforage-setitems";
import * as LocalforageRemoveitems from "localforage-removeitems";
import * as PageTournamentList$Coronate from "./PageTournamentList.res.js";

function App$App(props) {
  var url = Router$Coronate.useUrl();
  return JsxRuntime.jsx(Window$Coronate.make, {
              children: (function (windowDispatch) {
                  var tmp;
                  if (typeof url !== "object") {
                    switch (url) {
                      case "Index" :
                          tmp = JsxRuntime.jsx(Window$Coronate.Body.make, {
                                children: JsxRuntime.jsx(Pages$Coronate.Splash.make, {}),
                                windowDispatch: windowDispatch
                              });
                          break;
                      case "TournamentList" :
                          tmp = JsxRuntime.jsx(PageTournamentList$Coronate.make, {
                                windowDispatch: windowDispatch
                              });
                          break;
                      case "PlayerList" :
                          tmp = JsxRuntime.jsx(PagePlayers$Coronate.make, {
                                windowDispatch: windowDispatch
                              });
                          break;
                      case "TimeCalculator" :
                          tmp = JsxRuntime.jsx(Window$Coronate.Body.make, {
                                children: JsxRuntime.jsx(Pages$Coronate.TimeCalculator.make, {}),
                                windowDispatch: windowDispatch
                              });
                          break;
                      case "Options" :
                          tmp = JsxRuntime.jsx(PageOptions$Coronate.make, {
                                windowDispatch: windowDispatch
                              });
                          break;
                      case "NotFound" :
                          tmp = JsxRuntime.jsx(Window$Coronate.Body.make, {
                                children: JsxRuntime.jsx(Pages$Coronate.NotFound.make, {}),
                                windowDispatch: windowDispatch
                              });
                          break;
                      
                    }
                  } else {
                    tmp = url.TAG === "Tournament" ? JsxRuntime.jsx(PageTourney$Coronate.make, {
                            tourneyId: url._0,
                            subPage: url._1,
                            windowDispatch: windowDispatch
                          }) : JsxRuntime.jsx(PagePlayers$Coronate.make, {
                            id: Caml_option.some(url._0),
                            windowDispatch: windowDispatch
                          });
                  }
                  return JsxRuntime.jsx("main", {
                              children: tmp,
                              className: "app__main"
                            });
                }),
              className: "app"
            });
}

var App = {
  make: App$App
};

function init() {
  var root = document.querySelector("#root");
  if (root == null) {
    console.error("Couldn't find root.");
  } else {
    Client.createRoot(root).render(JsxRuntime.jsx(App$App, {}));
  }
}

LocalforageGetitems.extendPrototype(Localforage);

LocalforageRemoveitems.extendPrototype(Localforage);

LocalforageSetitems.extendPrototype(Localforage);

export {
  App ,
  init ,
}
/*  Not a pure module */
